/**
 * @author liujf
 * @create date 2018-09-04
 * @desc BPConfirm中间层
*/

import Vue from 'vue'
import BPConfirm from './BPConfirm.vue'

let baseData = {
    showConfirm: false,
    title: '确认',
    content: '是否确认该操作?',
    showIcon: true,
    icon: 'information-circled',
    iconColor: '#4eaffa',
    param: {},
    buttons: ['确定', {name: '取消', type: 'default', color: '#495060'}],
    width: '400px',
    transfer: true,
    maskClose: true
}

BPConfirm.newInstance = (prop = {}) => {
    let data = Object.assign({}, prop, {
        showConfirm: false,
        title: '确认',
        content: '是否确认该操作?',
        showIcon: true,
        icon: 'information-circled',
        iconColor: '#4eaffa',
        param: {},
        buttons: ['确定', {name: '取消', type: 'default', color: '#495060'}],
        width: '400px',
        transfer: true,
        maskClose: true
    })
    const nInstance = new Vue({ // 自己创建实例
        data: data,
        render (h) {
            return h(BPConfirm, {
                props: {
                    title: this.title,
                    content: this.content,
                    showIcon: this.showIcon,
                    icon: this.icon,
                    iconColor: this.iconColor,
                    param: this.param,
                    buttons: this.buttons,
                    width: this.width,
                    transfer: this.transfer,
                    maskClose: this.maskClose
                },
                domProps: {
                    value: this.showConfirm
                },
                on: {
                    input: (status) => {
                        this.showConfirm = status
                    },
                    close: () => {
                        this.onClose(this.param)
                    },
                    sure: (res) => {
                        if (res.btnIndex !== 0) return this.onClose(res)
                        this.onSure(res)
                    }
                }
            })
        },
        methods: {
            onSure () {},
            onClose () {},
            remove () {
                this.$destroy()
            }
        }
    })

    const component = nInstance.$mount() // 先渲染，返回实例本身
    document.body.appendChild(component.$el) // 手动挂载到body
    const bp_confirm = nInstance.$children[0] // 获取bpconfirm实例

    return {
        show (opt = {}) {
            let baseData = {
                showConfirm: false,
                title: '确认',
                content: '是否确认该操作?',
                showIcon: true,
                icon: 'information-circled',
                iconColor: '#4eaffa',
                param: {},
                buttons: ['确定', {name: '取消', type: 'default', color: '#495060'}],
                width: '400px',
                transfer: true,
                maskClose: true
            }
            bp_confirm.$parent.title = baseData.title
            if ('title' in opt) {
                bp_confirm.$parent.title = opt.title
            }
            bp_confirm.$parent.content = baseData.content
            if ('content' in opt) {
                bp_confirm.$parent.content = opt.content
            }
            bp_confirm.$parent.showIcon = baseData.showIcon
            if ('showIcon' in opt) {
                bp_confirm.$parent.showIcon = opt.showIcon
            }
            bp_confirm.$parent.buttons = baseData.buttons
            if ('buttons' in opt) {
                bp_confirm.$parent.buttons = opt.buttons
            }
            bp_confirm.$parent.width = baseData.width
            if ('width' in opt) {
                bp_confirm.$parent.width = opt.width
            }
            bp_confirm.$parent.icon = baseData.icon
            if ('icon' in opt) {
                bp_confirm.$parent.icon = opt.icon
            }
            bp_confirm.$parent.maskClose = baseData.maskClose
            if ('maskClose' in opt) {
                bp_confirm.$parent.maskClose = opt.maskClose
            }
            bp_confirm.$parent.transfer = baseData.transfer
            if ('transfer' in opt) {
                bp_confirm.$parent.transfer = opt.transfer
            }
            bp_confirm.$parent.iconColor = baseData.iconColor
            if ('iconColor' in opt) {
                bp_confirm.$parent.iconColor = opt.iconColor
            }
            bp_confirm.$parent.param = {}
            if ('param' in opt) {
                bp_confirm.$parent.param = opt.param
            }
            bp_confirm.$parent.onSure = function () {}
            if ('onSure' in opt) {
                bp_confirm.$parent.onSure = opt.onSure
            }
            bp_confirm.$parent.onClose = function () {}
            if ('onClose' in opt) {
                bp_confirm.$parent.onClose = opt.onClose
            }
            bp_confirm.visible = true
        },
        remove () {
            instance = undefined
            bp_confirm.$parent.remove()
        }
    }
}

let instance

function getInstance (render = undefined) {
    instance = instance || BPConfirm.newInstance()
    return instance
}

function confirm (opt) {
    let ins = getInstance()
    ins.show(opt)
}

BPConfirm.confirm = (props = {}) => {
    return confirm(props)
}

BPConfirm.remove = (props = {}) => {
    if (!instance) {
        return false
    }
    instance.remove()
}

export default BPConfirm
